<template>
  <a-drawer width="55%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-row>
        <a-col>
          <a-form-model-item prop="merchantId" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <span slot="label" ><a-tooltip>{{$t('选择商家')}}<template slot="title">{{$t('选择商家')}}</template></a-tooltip> </span>
            <a-button plain   @click="openMerchantSelect">
              <span>{{this.getMerchantName()}}</span>
            </a-button>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <a-form-model-item prop="fromStoreId" :label-col="{span: 6}" :wrapper-col="{span: 16}">
            <span slot="label" ><a-tooltip>{{$t('来源门店')}}<template slot="title">{{$t('来源门店')}}</template></a-tooltip> </span>
            <a-button plain   @click="openFromStoreSelect">
              <span>{{this.getFromStoreName()}}</span>
            </a-button>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item prop="toStoreId" :label-col="{span: 6}" :wrapper-col="{span: 16}">
            <span slot="label" ><a-tooltip>{{$t('目标门店')}}<template slot="title">{{$t('目标门店')}}</template></a-tooltip> </span>
            <a-button plain   @click="openToStoreSelect">
              <span>{{this.getToStoreName()}}</span>
            </a-button>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col>
          <a-form-model-item prop="remark" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <span slot="label" ><a-tooltip>{{$t('备注')}}<template slot="title">{{$t('备注')}}</template></a-tooltip> </span>
            <a-input v-model="form.remark" :placeholder="$t('请输入')" type="textarea" allow-clear />
          </a-form-model-item>
        </a-col>
      </a-row>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" v-if="formType===1" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
    <a-button type="primary" :loading="submitLoading" v-if="formType===1" @click="openSkuSelect">
      选择调拨商品
    </a-button>
    <a-button  v-if="formType===1" @click="$refs.importExcel.importExcelHandleOpen()">
      <a-icon type="import" />表格导入
    </a-button>
    <a-button @click="handleDeleteAllSku()" v-if="formType===1 && form.goodsTransferList.length > 1">
      删除全部商品
    </a-button>
    <a-divider orientation="left">
      <b>商品入库明细</b>
    </a-divider>
    <a-table
      :loading="loading"
      :size="tableSize"
      rowKey="id"
      :columns="columns"
      childrenColumnName="ch"
      :data-source="form.goodsTransferList"
      :pagination="false"
      :bordered="tableBordered">
      <template slot="picture" slot-scope="text, record">
        <div>
          <img v-if="record.picture" :src="record.picture"  style="width:60px;height:62px;" @click="handleRecordPreview(record.picture)" alt="none"/>
        </div>
      </template>
      <div slot="goodsCount" slot-scope="text, record">
        <a-input-number :min="0" v-model="record.goodsCount"  placeholder="数量"  />
      </div>
      <span slot="operation" slot-scope="text, record">
        <a @click="handleDeleteSku(record.id)" v-if="formType===1">
          <a-icon type="delete" />{{$t('删除')}}
        </a>
      </span>
    </a-table>
    <merchant-select ref="merchantSelect" @merchantSelected="handleMerchantSelected"></merchant-select>
    <store-radio ref="storeRadio" @fromStoreSelected="handleFromStoreSelected" @toStoreSelected="handleToStoreSelected"></store-radio>
    <import-excel ref="importExcel" @excelGoods="indexGoodsImport"></import-excel>
    <sku-checkbox-select ref="skuSelect" @skuSelect="indexSkuSelect"></sku-checkbox-select>

  </a-drawer>
</template>

<script>
  import { getOrderTransfer, addOrderTransfer, updateOrderTransfer } from '@/api/order/orderTransfer'
  import {mapGetters} from 'vuex'
  import CustomDictTag from "@/components/DictCustomTag";
  import {generateFilePath, uploadObject} from "@/api/tool/oss";
  import LocaleFieldButton from "@/components/locale/LocaleFieldButton.vue";
  import moment from 'moment';
  import {tableMixin} from "@/store/table-mixin";
  import MerchantSelect from "@/views/merchant/merchant/select/merchantRadio.vue";
  import StoreRadio from "@/views/merchant/merchantStore/select/storeRadio.vue";
  import SkuCheckboxSelect from "@/views/goods/goods/select/SkuCheckboxSelect.vue";
  import ImportExcel from "../modules/ImportExcel.vue";


  export default {
    name: 'CreateForm',
    props: {
    },
    mixins: [tableMixin],
    components: {
      MerchantSelect,
      StoreRadio,
      SkuCheckboxSelect,
      ImportExcel,
      CustomDictTag,
      LocaleFieldButton,
    },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: false,
      // 表单参数
      form: {
        id: null,
        orderType: null,
        merchantId: null,
        merchantName: null,
        fromStoreId: null,
        fromStoreName: null,
        toStoreId: null,
        toStoreName: null,
        goodsCount: null,
        remark: null,
        goodsTransferList: [],
        localeFieldMap:{},
      },

      columns: [
      ],
      addColumns: [
        {
          title: 'sku名称',
          dataIndex: 'skuName',
          align: 'left',
        },
        {
          title: '商品编号',
          dataIndex: 'goodsId',
          align: 'left',
        },
        {
          title: '商品名称',
          dataIndex: 'goodsName',
        },
        {
          title: '图片',
          dataIndex: 'picture',
          scopedSlots: {customRender: 'picture'},
        },
        {
          title: '调拨数量',
          dataIndex: 'goodsCount',
          scopedSlots: {customRender: 'goodsCount'},
        },
        {
          title: '操作',
          dataIndex: 'operation',
          scopedSlots: {customRender: 'operation'},
          align: 'center'
        }
      ],
      infoColumns: [
        {
          title: 'sku名称',
          dataIndex: 'skuName',
          align: 'left',
        },
        {
          title: '商品编号',
          dataIndex: 'goodsId',
          align: 'left',
        },
        {
          title: '商品名称',
          dataIndex: 'goodsName',
        },
        {
          title: '图片',
          dataIndex: 'picture',
          scopedSlots: {customRender: 'picture'},
        },
        {
          title: '调拨数量',
          dataIndex: 'goodsCount',
        },
      ],
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
          orderType: [{ required: true, message: this.$t('订单类型')+this.$t('不能为空'), trigger: 'change' }] ,
          merchantId: [{ required: true, message: this.$t('商家ID')+this.$t('不能为空'), trigger: 'change' }] ,
          fromStoreId: [{ required: true, message: this.$t('来源门店ID')+this.$t('不能为空'), trigger: 'change' }] ,
          toStoreId: [{ required: true, message: this.$t('目标门店ID')+this.$t('不能为空'), trigger: 'change' }] ,
          goodsCount: [{ required: true, message: this.$t('调拨数量')+this.$t('不能为空'), trigger: 'blur' }]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    moment,
    onClose () {
      this.cancel()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        orderType: null,
        merchantId: null,
        merchantName: null,
        fromStoreId: null,
        fromStoreName: null,
        toStoreId: null,
        toStoreName: null,
        goodsCount: null,
        remark: null,
        goodsTransferList: [],
        localeFieldMap:{},
      }

    },
    getMerchantName() {
      if (this.form.merchantId) {
        return this.form.merchantName
      } else {
        return this.$t('请选择')+this.$t('商家')
      }
    },
    openMerchantSelect() {
      this.$refs.merchantSelect.openGoods(this.form.merchantId)
    },
    handleMerchantSelected(merchant) {
      this.form.merchantId = merchant.id
      this.form.merchantName = merchant.merchantName
    },
    openFromStoreSelect() {
      if (!this.form.merchantId) {
        this.$message.error("请先选择商家")
        return
      }
      let excludeList = this.form.toStoreId == null ? [] : [this.form.toStoreId];
      this.$refs.storeRadio.openGoods(this.form.merchantId, this.form.fromStoreId, excludeList, "fromStoreSelected");
    },
    getFromStoreName() {
      if (this.form.fromStoreId) {
        return this.form.fromStoreName
      } else {
        return this.$t('请选择')+this.$t('来源门店')
      }
    },
    handleFromStoreSelected(store) {
      this.form.fromStoreId = store.id
      this.form.fromStoreName = store.storeName
    },

    openToStoreSelect() {
      if (!this.form.merchantId) {
        this.$message.error("请先选择商家")
        return
      }
      let excludeList = this.form.fromStoreId == null ? [] : [this.form.fromStoreId];
      this.$refs.storeRadio.openGoods(this.form.merchantId, this.form.toStoreId, excludeList, "toStoreSelected");
    },
    getToStoreName() {
      if (this.form.toStoreId) {
        return this.form.toStoreName
      } else {
        return this.$t('请选择')+this.$t('目标门店')
      }
    },

    handleToStoreSelected(store) {
      this.form.toStoreId = store.id
      this.form.toStoreName = store.storeName
    },



    openSkuSelect () {
      if (!this.form.merchantId) {
        this.$message.error("请先选择商家")
        return
      }
      this.$refs.skuSelect.openGoods(this.form.goodsTransferList,[this.form.merchantId],null);
    },
    indexSkuSelect(records, index) {
      console.log('商品拿到',index, records)
      records.forEach(e => {
        if (this.form.goodsTransferList.filter(g=>g.id===e.id).length>0) {
          //如果存在则不管
        } else {
          this.form.goodsTransferList.push(e)
        }
      });
    },
    indexGoodsImport(records) {
      records.forEach(e => {
        if (this.form.goodsTransferList.filter(g=>g.id===e.id).length>0) {
          //如果存在则不管
        } else {
          this.form.goodsTransferList.push(e)
        }
      });
    },

    handleDeleteSku(id) {
      let filter = this.form.goodsTransferList.filter(e => e.id !== id);
      this.form.goodsTransferList =filter;
    },

    handleDeleteAllSku() {
      this.form.goodsTransferList =[];
    },


    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },

    /** 新增按钮操作 */
    handleAdd (merchantId, merchantName) {
      this.reset()
      this.columns = this.addColumns
      this.form.merchantId = merchantId
      this.form.merchantName = merchantName
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.columns = this.infoColumns
      this.formType = 2
      const id = row ? row.id : ids
      getOrderTransfer({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateOrderTransfer(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addOrderTransfer(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
  }
</script>
